module.exports = __webpack_public_path__ + "static/media/Close.d47201d9.svg";